const qa = [
  {
    image: 1,
    question: 'Lorsque vous doutez si une matière va au recyclage ou non, que faites-vous?',
    answers: [
      {
        txt: 'Je mets la matière au recyclage! Il y a au centre de tri des personnes plus compétentes que moi qui pourront disposer de la matière au bon emplacement!',
        points: 1
      },
      {
        txt: 'Je mets la matière à la poubelle!',
        points: 0
      },
      {
        txt: 'Je m’informe pour savoir où va la matière.',
        points: 2
      }
    ],
    recap: 'En effet, nous recommandons aux citoyens de consulter l’outil <a href="https://tricycle-mrcvs.ca/points-de-services/" target="_blank">Tricycle de la MRC</a> avant tout, pour s’assurer que le plus de bonnes matières se retrouvent au bon endroit.'
  },
  {
    image: 1,
    question: 'Pour vous aider à bien organiser le tri à la maison et pour vous faciliter la tâche quand vient le temps de sortir les matières recyclables, comment procédez-vous?',
    answers: [
      {
        txt: 'J’ai des sacs en plastique transparent, que je mets directement dans le bac bleu. Comme on peut voir au travers, les matières qui s’y trouvent seront recyclées.',
        points: 1
      },
      {
        txt: 'Je mets ma matière dans des sacs opaques (par exemple des sacs d’épicerie) que je dépose ensuite dans mon bac bleu.',
        points: 0
      },
      {
        txt: 'Je transverse directement mes matières dans le bac bleu sans utiliser de sacs plastiques. Seuls les sacs de plastique sont mis dans un sac, sac de sacs.',
        points: 2
      }
    ],
    recap: 'Au centre de tri, les sacs opaques sont considérés comme des poubelles, parce que souvent, cela en est réellement. Et pour offrir des conditions de travail les plus dignes possibles aux trieurs, ils ont la consigne de ne pas ouvrir les sacs opaques.'
  },
  {
    image: 1,
    question: 'Lorsque vous recevez un colis par la poste, que faites-vous de la boîte et des multiples emballages?',
    answers: [
      {
        txt: 'J’enlève les multiples emballages de la boîte et je m’assure qu’ils sont recyclables avant de les mettre dans le bac, puis je découpe la boîte de carton et je la mets au recyclage.',
        points: 2
      },
      {
        txt: 'Je mets la boîte et tout son contenu directement dans le bac bleu.',
        points: 1
      },
      {
        txt: 'Je mets la boîte dans le bac bleu et je jette le restant de l’emballage à l’intérieur de la boîte.',
        points: 0
      }
    ],
    recap: 'Il est important que les matières recyclables (carton et papier bulle par exemple) soient bien séparées avant d’être mises dans le bac bleu, ceci facilite le travail au centre de tri. Aussi, les boîtes de carton découpées seront également plus faciles à traiter au centre de tri et prendront moins de place dans ton bac bleu!'
  },
  {
    image: 1,
    question: 'Quand vous prenez pour emporter une excellente poutine remplie de fromage <em>skouik skouik</em>, que faites-vous de l’assiette d’aluminium (pour de vrai) ?',
    answers: [
      {
        txt: 'Je la mets au recyclage sans la rincer.',
        points: 1
      },
      {
        txt: 'Je la rince et ensuite je la mets au recyclage. Je ne veux pas qu’une semaine plus tard, au centre de tri, une personne touche et sente du moisi constamment.',
        points: 2
      },
      {
        txt: 'Je la mets à la poubelle. De toute façon, ce n’est pas si écologique d’utiliser de l’eau.',
        points: 0
      }
    ],
    recap: 'Le centre de tri n’est pas équipé pour laver les matières souillées. Donc, le personnel qui trie les matières au centre peut être exposé à plus de 262 fois la concentration normale de contaminants dans l’air comme les moisissures et les bactéries. Aussi, il sera toujours plus écologique d’utiliser un peu d’eau pour nettoyer son assiette, que les 125 millions de litres d’eau qui sont nécessaires pour produire une tonne d’aluminium.'
  },
  {
    image: 1,
    question: 'Maintenant que votre assiette d’aluminium est nettoyée et recyclée, que faites-vous en temps normal du couvercle de cette excellente poutine ?',
    answers: [
      {
        txt: 'Je le recycle.',
        points: 1
      },
      {
        txt: 'Je le mets à la poubelle.',
        points: 0
      },
      {
        txt: 'Je regarde d’abord le chiffre qui y figure! Si c’est un plastique #1, je le recycle. Si c’est un #6, je l’apporte à l’écocentre.',
        points: 2
      }
    ],
    recap: 'Et oui, le plastique #6 se recycle, mais il est souvent boudé par les recycleurs? C’est pourquoi, la MRC de Vaudreuil-Soulanges fait directement affaire avec 2 entreprises de la région. Leur méthode, <a href="https://ici.radio-canada.ca/nouvelle/1417071/recyclage-plastique-dechets-chimie-quebec-loop-pyrowave-environnement" target="_blank">le recyclage moléculaire</a>, permet d’avoir une plus grande qualité de plastique. De plus cela est plus écologique car le plastique voyage moins étant valorisé ici dans notre région. <a href="https://www.youtube.com/watch?v=nb_OtcTTkbY&t=51s" target="_blank">Consultez cette capsule</a> pour d’autres astuces quand vous apportez votre polystyrène à l’écocentre'
  },
  {
    image: 1,
    question: 'Bien sûr, après toute cette poutine, on ressent un peu de fatigue. Un petit café d’après-midi vous permettra de vous garder éveillé. En général, comment prenez-vous votre café?',
    answers: [
      {
        txt: 'Dans une tasse en carton que je jette.',
        points: 0
      },
      {
        txt: 'Dans une tasse en styromousse à usage unique que je rapporte à l’écocentre en même temps que tous mes autres contenant #6.',
        points: 1
      },
      {
        txt: 'Dans une tasse réutilisable.',
        points: 2
      }
    ],
    recap: 'Bien que certaines tasses en carton ne sont pas recyclables, car elles sont composées de plusieurs couches de matière dont du polyéthylène, la plupart, (comme celle du Tim ) se recyclent. D’ailleurs ces tasses sont “déchirables” et on peut voir la fibre du papier ou du carton entre les couches imperméables. Ce sont ces fibres qu’il est possible de recycler. Pour ce qui est du styromousse, comme le plastique #6, vous pouvez le rapporter à l’écocentre le plus près de chez vous. Mais en matière de café, le plus écologique reste évidemment la tasse réutilisable.<br/><br/><a href="https://tricycle-mrcvs.ca/matiere/plastique-6-polystyrene-styrofoam/" target="_blank">https://tricycle-mrcvs.ca/matiere/plastique-6-polystyrene-styrofoam/</a>'
  },
  {
    image: 1,
    question: 'Quand vous êtes au parc et que vous devez vous débarrasser de votre contenant à usage unique #1, mais qu’il reste un fond de smoothie à l’intérieur, que faites-vous?',
    answers: [
      {
        txt: 'Je me rend à l’îlot de tri le plus proche. Je vide le smoothie dans le bac brun lorsque disponible, et secoue le contenant pour enlever au mieux l’excédent de liquide. Je termine en mettant le contenant au recyclage.',
        points: 2
      },
      {
        txt: 'Je me rend à l’îlot de tri le plus proche. Je mets tout le contenant au recyclage avec son contenu! Je me dis qu’une fois n’est pas coutume.',
        points: 1
      },
      {
        txt: 'Marcher jusqu’à l’îlot de tri! C’est beaucoup trop épuisant. Je jette ça par terre!',
        points: 0
      }
    ],
    recap: 'Le hic avec les matières souillées, c’est qu’elles peuvent contaminer les autres matières dans le bac et ensuite dans le camion. Donc même quand vous êtes à l’extérieur, pensez à vider vos contenants.'
  },
  {
    image: 1,
    question: '<span>Nous venons d’en avoir un aperçu, mais des matières se retrouvent à l’enfouissement même si elles ont été envoyées au recyclage… parce qu’elles ne se recyclent pas. C’est ce qu’on appelle les matières orphelines.</span>Est-ce que votre pratique du tri est exemplaire et permet de valoriser l’ensemble des matières que vous envoyez au recyclage?',
    answers: [
      {
        txt: 'Oui, 100% de mes matières sont recyclables: les matières sont propres, je n’utilise pas de sac opaque pour envoyer mes matières au recyclage et je m’informe sur ce qui se recycle et ne se recycle pas.',
        points: 2
      },
      {
        txt: 'Non, comme la moyenne nationale, je dois envoyer 10% de matières au recyclage qui finalement ne seront pas recyclés, car ma pratique n’est pas exemplaire et parce que je ne m’informe pas assez.',
        points: 1
      },
      {
        txt: 'Non, et ce n’est pas grave, car la majorité s’en va à la poubelle!',
        points: 0
      }
    ],
    recap: 'On estime que 10% des matières qui sont envoyées au centre de tri finissent à l’enfouissement, car ces matières n’ont tout simplement pas d’affaire là.'
  },
  {
    image: 1,
    question: '<span>Question boni pour l’obtention de votre maîtrise en tri!</span>Savez-vous où sont envoyés les déchets lorsqu’ils partent de votre maison pour la direction du site d’enfouissement?',
    answers: [
      {
        txt: 'Dans un site d’élimination de la région, qui est dédiée spécifiquement à notre MRC.',
        points: 1
      },
      {
        txt: 'Dans un lieu d’enfouissement technique à Terrebonne, avec tous les autres déchets du Grand Montréal.',
        points: 2
      },
      {
        txt: 'À l’étranger, avec tous les déchets du Québec.',
        points: 0
      }
    ],
    recap: 'Nos déchets sont envoyés à Terrebonne, à 95 km de Vaudreuil-Soulanges, et on évalue qu’il reste <a href="https://www.lapresse.ca/actualites/environnement/2019-07-06/la-plus-grosse-poubelle-du-quebec-bientot-pleine" target="_blank">9 ans à ce site d’enfouissement avant qu’il ne déborde complètement</a>! Voilà pourquoi il est si important de réduire à la source, réutiliser et recycler le plus de matières possible.'
  },
  {
    image: 1,
    question: 'Selon vous quelle sera votre note globale et qu’est-ce que vous vous engagez à faire pour la suite ?',
    answers: [
      {
        txt: 'J’assume que ma note sera très basse, comme je ne fais presque pas ou peu d’efforts en ce qui a trait au tri des matières recyclables. Je prends la décision de ne pas me préoccuper de l’enjeu environnemental et de payer plus cher pour la gestion de mes matières résiduelles.',
        points: 0
      },
      {
        txt: 'Ce n’est pas tout parfait, mais je vais changer certaines habitudes.',
        points: 1
      },
      {
        txt: 'Peu importe, je vais tout faire pour avoir une meilleure empreinte déchet possible et je m’engage aussi à influencer mon entourage en ce sens (famille, bureau, communauté).',
        points: 2
      }
    ],
    recap: ' '
  }
]

export default qa
